/**
 * Decode the payload of a JWT without verifying its signature.
 * Use only for reading non-sensitive claims (e.g. impersonated_by) so the UI
 * can react to them. Trust decisions still happen server-side.
 */
export function decodeJwtClaims<T = Record<string, unknown>>(
  token: string | null | undefined,
): T | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    let payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = payload.length % 4;
    if (pad) payload += "=".repeat(4 - pad);
    return JSON.parse(atob(payload)) as T;
  } catch {
    return null;
  }
}
